import type { FC, ReactNode } from "react";

import { wrapper } from "./SignInWrapper.styles";

interface Props {
  children: ReactNode;
}

const SignInWrapper: FC<Props> = ({ children, ...rest }) => {
  return (
    <div css={wrapper} {...rest}>
      {children}
    </div>
  );
};

export { SignInWrapper };
